import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce86c896"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = ["placeholder"]

import { reactive, ref, toRefs } from "vue";
import { required, minLength, maxLength, email } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import LoadingIcon from "@/components/LoadingIcon.vue";
import { saveContactUs } from "@/services/portalService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {

const model = reactive({
  name: "",
  email: "",
  phone: "",
  message: "",
});

const rules = {
  name: {
    required,
    minLength: minLength(3),
    maxLength: maxLength(50),
  },
  email: {
    required,
    minLength: minLength(5),
    maxLength: maxLength(500),
    email,
  },
  phone: {
    required,
    minLength: minLength(10),
    maxLength: maxLength(20),
  },
  message: {
    required,
    minLength: minLength(10),
    maxLength: maxLength(1000),
  },
};
const isLoading = ref(false);

const validate = useVuelidate(rules, toRefs(model));

const sendMessage = async () => {
  console.log("msg");
  if (isLoading.value) return;
  validate.value.$touch();
  if (validate.value.$invalid) return;
  isLoading.value = true;

  saveContactUs(model).then(
    (response) => {
      model.name = "";
      model.email = "";
      model.phone = "";
      model.message = "";
      isLoading.value = false;
    },
    (err) => {
      model.name = "";
      model.email = "";
      model.phone = "";
      model.message = "";
      console.log(err);
      isLoading.value = false;
    }
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("contact.title")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("contact.desc")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", null, [
          _withDirectives(_createElementVNode("input", {
            name: "name",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.name) = $event)),
            class: _normalizeClass({ 'border-danger': _unref(validate).name.$error }),
            placeholder: _ctx.$t('contact.form.name')
          }, null, 10, _hoisted_5), [
            [_vModelText, model.name]
          ]),
          _withDirectives(_createElementVNode("input", {
            name: "email",
            type: "email",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.email) = $event)),
            class: _normalizeClass({ 'border-danger': _unref(validate).email.$error }),
            placeholder: _ctx.$t('contact.form.email')
          }, null, 10, _hoisted_6), [
            [_vModelText, model.email]
          ]),
          _withDirectives(_createElementVNode("input", {
            name: "phone",
            type: "tel",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.phone) = $event)),
            class: _normalizeClass({ 'border-danger': _unref(validate).phone.$error }),
            placeholder: _ctx.$t('contact.form.phone')
          }, null, 10, _hoisted_7), [
            [_vModelText, model.phone]
          ]),
          _withDirectives(_createElementVNode("textarea", {
            name: "message",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.message) = $event)),
            class: _normalizeClass({ 'border-danger': _unref(validate).message.$error }),
            cols: "30",
            rows: "10",
            placeholder: _ctx.$t('contact.form.message')
          }, null, 10, _hoisted_8), [
            [_vModelText, model.message]
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: sendMessage
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("contact.form.btn-send")) + " ", 1),
            (isLoading.value)
              ? (_openBlock(), _createBlock(LoadingIcon, {
                  key: 0,
                  icon: "three-dots",
                  color: "EF3A5D",
                  class: "w-4 h-4 ml-2"
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})